import { TrackEvent } from '@alycecom/services';

import { RECIPIENT_SEGMENT_PREFIX, RECIPIENT_APP_NAME as appName } from '../constants/events.constants';

export const analyticService = TrackEvent.createAnalyticService({
  staticPayload: { appName },
  prefix: RECIPIENT_SEGMENT_PREFIX,
  options: { app: { name: appName } },
});
